import { render, staticRenderFns } from "./ShopifyStockAdd.vue?vue&type=template&id=1b5afc58&"
import script from "./ShopifyStockAdd.vue?vue&type=script&lang=js&"
export * from "./ShopifyStockAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopifyStockAdd.vue"
export default component.exports